import React from 'react';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
export const SortDirectionArrow = ({ sortDirection, isTimestamp }) => {
    console.log('IN SIDE OF SORT DIRECTION ARROW: ');
    console.log(sortDirection);
    console.log(isTimestamp);
    if (isTimestamp) {
        if (sortDirection === 'ASC') {
            return (React.createElement(ArrowUpward, { style: { height: '15px' } }));
        }
        else {
            return (React.createElement(ArrowDownward, { style: { height: '15px' } }));
        }
    }
    else {
        if (sortDirection === 'ASC') {
            return (React.createElement(ArrowDownward, { style: { height: '15px' } }));
        }
        else {
            return (React.createElement(ArrowUpward, { style: { height: '15px' } }));
        }
    }
};
